const emitir_atas_finais = [
  {
    path: "/emitir-atas-finais",
    name: "emitir_atas_finais",
    meta: {
      allowedPermissions: ["atasfinais_atas_finais_pdf"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () => import("@/views/EmitirAtasFinais/EmitirAtasFinais.vue"),
  },
];

export { emitir_atas_finais };
